import { useState } from 'react';
import { Text } from '@rsos/base-components';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import DeleteMessageModal from '../modals/DeleteMessageModal';
import ManageMessageModal from '../modals/ManageMessageModal';
import {
  EmptyState,
  NoResultsState,
  TableError,
  TableLoading,
} from '../tableShared';
import {
  Wrapper,
  TableWrapper,
  EmptyStateCell,
} from '../tableShared/index.styles';
import CustomMessagesTableRow from './TableRow';

const TABLE_HEIGHT = 312;
const TABLE_HEIGHT_NO_HEADER = 272;

const CustomMessagesTable = ({
  messages,
  searchTerm,
  isLoading,
  isError,
}: {
  messages: PreconfiguredResponse[];
  searchTerm: string;
  isLoading: boolean;
  isError: boolean;
}) => {
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);
  const [isManageMessageModalOpened, setIsManageMessageModalOpened] =
    useState(false);
  const [message, setMessage] = useState<PreconfiguredResponse | null>(null);

  const handleDeleteModal = (customMessage: PreconfiguredResponse) => {
    setMessage(customMessage);
    setIsDeleteModalOpened(true);
  };
  const handleCloseModal = () => {
    setIsDeleteModalOpened(false);
    setMessage(null);
  };
  const handleManageModal = (customMessage: PreconfiguredResponse) => {
    setMessage(customMessage);
    setIsManageMessageModalOpened(true);
  };
  const handleManageModalClose = () => {
    setIsManageMessageModalOpened(false);
    setMessage(null);
  };
  if (isLoading) return <TableLoading height={TABLE_HEIGHT} />;
  if (isError) return <TableError height={TABLE_HEIGHT} />;
  return (
    <Wrapper>
      <Text size="large" fontWeight="bold" mb={16}>
        Custom Preconfigured Messages
      </Text>
      <TableWrapper height={TABLE_HEIGHT}>
        <table>
          <thead>
            <tr>
              <th>Message Title</th>
              <th>Message Body</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 ? (
              <tr>
                <EmptyStateCell height={TABLE_HEIGHT_NO_HEADER}>
                  {searchTerm ? <NoResultsState /> : <EmptyState />}
                </EmptyStateCell>
              </tr>
            ) : (
              messages.map(customMessage => (
                <CustomMessagesTableRow
                  key={customMessage.id}
                  customMessage={customMessage}
                  handleDeleteModal={handleDeleteModal}
                  handleManageModal={handleManageModal}
                />
              ))
            )}
          </tbody>
        </table>
      </TableWrapper>
      {isDeleteModalOpened && message && (
        <DeleteMessageModal
          isOpened={isDeleteModalOpened}
          onClose={handleCloseModal}
          message={message}
        />
      )}
      {isManageMessageModalOpened && message && (
        <ManageMessageModal
          isOpened={isManageMessageModalOpened}
          onClose={handleManageModalClose}
          message={message}
          isEdit={true}
        />
      )}
    </Wrapper>
  );
};

export default CustomMessagesTable;
